import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    priceInput: {
        width: '150px'
    }
}))

export default useStyles